<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :useModelInsteadOfButton="useModelInsteadOfButton"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_OIL_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.oil;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(oil) {
      // console.log("OIL", oil, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(oil, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_OIL_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(oil, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createOil.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createOil.item);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_OIL_QUERY = gql `
  {
    accountContext{
      oil {
        id
        description
        barcode
        groupId
        group {
          name
        }
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }
        packagingIds
        validations
      }
    }
    globalContext {
      allUnits {
        id
        name
      }
    } 
    accountGlobalSharedContext {
      allGroupsForOils {
        id
        name
      }
      allBrandsOfItems {
        id
        name
      }
    }
  }
`;

const CREATE_OIL_MUTATION = gql `
  mutation($input: OilCreateInputObject!) {
    createOil(input: $input) {
      item {
        id
        name
        description
        barcode
        groupId
        group {
          name
        }
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }
        packagingIds
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
